/**
 * The free first storyboard (TRY-2) — read-only client. The entitlement itself only moves on the server, inside the
 * script and preview-frame handlers; the client just asks where it stands so the Studio can say so.
 */
import { callFunction } from '../utils/apiClient';

export type TrialState = 'available' | 'in_use' | 'used';

export interface TrialStatus {
  state: TrialState;
  /** The one storyboard the trial is bound to once it starts, else null. */
  storyboardId: string | null;
  scriptPassesLeft: number;
  framesLeft: number;
  framesUsed: number;
}

export const getTrialStatus = () => callFunction<TrialStatus>('getTrialStatus', {});
